// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Module reducers and selectors
import { AppState} from '../../../core/reducers/';
import { authRole } from '../_selectors/auth.selectors';
import { ENUM } from '../../enum/enum';
import { Logout } from '../_actions/auth.actions';

@Injectable()
export class ModuleGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }
    role_id;
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>  {

        const moduleName = route.data['moduleName'];
        if (!moduleName) {
            return of(false);
        }

        return this.store
            .pipe(
                select(authRole),
                map((role) => {
                    this.role_id = +role;
					let _perm = moduleName.find(m => m == +role);
                    return _perm ? true : false;
                }),
                tap(hasAccess => {
                    if (!hasAccess) {
                        if(this.role_id === ENUM.roles.CASHIER){
                            this.router.navigateByUrl('/cashier');
                        }else if(this.role_id === ENUM.roles.ADMIN){
                            this.router.navigateByUrl('/dashboard');
                        }else if(this.role_id === ENUM.roles.FINANCIAL){
                            this.router.navigateByUrl('/cashier-management/shifts');
                        }else if(this.role_id === ENUM.roles.OPERATION){
                            this.router.navigateByUrl('/queue-management/requests');
                        }else if(this.role_id === ENUM.roles.AIRPORT){
                            this.router.navigateByUrl('/dashboard');
                        }else if(this.role_id === ENUM.roles.COMPANY_DRIVER){
                            this.router.navigateByUrl('/driver/balance');
                        }else{
                            this.store.dispatch(new Logout());
                        }
                    }
                })
            );
    }
}
